<ngx-premium-trial-reminder></ngx-premium-trial-reminder>
<button
  i18n="@@Back"
  nbButton
  type="submit"
  status="basic"
  class="back mb-2 btn-circle btn-xl"
  [routerLink]="['/pages/CalorieFriend/Patients']"
>
  <nb-icon icon="arrow-ios-back-outline"></nb-icon>Back to Clients
</button>

<nb-card>
  <nb-card-header>
    <div class="title">
      <strong>{{ patientFullName }}</strong> <br><div class="howto" *ngIf="patientSubscriptionItem?.itemDescription">Package: {{patientSubscriptionItem?.itemDescription}}</div>
    </div>

    <button nbButton class="btn-circle btn-xl btn-main pull-right" type="submit" [nbSpinner]="loading"
    [disabled]="loading" (click)="onSend()">
      <i class="fas fa-mobile-alt"></i>&nbsp;Send App Invite
    </button>

  </nb-card-header>

  <nb-card-body>
    <mat-tab-group
      class="tab"
      [class.during-tutorial]="joyrideService.isTourInProgress()"
      #tabGroup
      (selectedTabChange)="onChangeTab($event)"
    >



    <mat-tab i18n-tabTitle="@@Program" label="Program" tabindex="0" >
      <ng-template mat-tab-label>
        <span class="fas fa-calendar-alt"></span>
        <span class="ml-1">Program</span>
      </ng-template>
      <ngx-program-overview *ngIf="currentIndex === 0" #programOverviewComponent></ngx-program-overview>
    </mat-tab>

      <!-- Workout Plans -->
      <mat-tab
        i18n-tabTitle="@@WorkoutPlans"
        label="Workout Plans"
        tabindex="1"
      >
        <ng-template mat-tab-label>
          <span class="fas fa-dumbbell"></span>
          <span class="ml-1">Workout Plans</span>
        </ng-template>
        <app-patient-program  *ngIf="currentIndex === 1" [isFitness]="true"></app-patient-program>
      </mat-tab>

      <!-- Meal Plans -->
      <mat-tab i18n-tabTitle="@@MealPlans" label="Meal Plans" tabindex="2">
        <ng-template mat-tab-label>
          <span class="fas fa-utensils"></span>
          <span class="ml-1">Meal Plans</span>
        </ng-template>
        <app-patient-program *ngIf="currentIndex === 2" [isFitness]="false"></app-patient-program>
      </mat-tab>

      <!-- Macro Goals -->
      <mat-tab i18n-tabTitle="@@MacroGoals" label="Macro Goals" tabindex="3">
        <ng-template mat-tab-label>
          <span class="fas fa-carrot"></span>
          <span class="ml-1">Macro Goals</span>
        </ng-template>
        <app-macro-goals *ngIf="currentIndex === 3"></app-macro-goals>
      </mat-tab>

      <!-- Goals -->
      <mat-tab i18n-tabTitle="@@Goals" label="Goals" tabindex="4">
        <ng-template mat-tab-label>
          <span class="fas fa-bullseye"></span>
          <span class="ml-1">Goals</span>
        </ng-template>
        <app-goals-list-view *ngIf="currentIndex === 4" #goals [IsView]="false"></app-goals-list-view>
      </mat-tab>

      <!-- Progress -->
      <mat-tab i18n-tabTitle="@@Progress" label="Progress" tabindex="5">
        <ng-template mat-tab-label>
          <span class="fas fa-chart-line"></span>
          <span class="ml-1">Progress</span>
        </ng-template>
        <app-patient-progress *ngIf="currentIndex === 5"></app-patient-progress>
      </mat-tab>

      <!-- General Info -->
      <mat-tab i18n-tabTitle="@@GeneralInfo" label="General Info" tabindex="6">
        <ng-template mat-tab-label>
          <span class="fas fa-file-alt"></span>
          <span class="ml-1">General Info</span>
        </ng-template>
        <app-patient-general-info
          #generalInfo
          [IsView]="false"
          *ngIf="currentIndex === 6"
        ></app-patient-general-info>
      </mat-tab>
    </mat-tab-group>
  </nb-card-body>
</nb-card>
